import React from "react";
import { pure } from "recompose";

import { isAccepted } from "services/utils";
import Goal from "./Goal";

const OPGoals = pure(({ products }) => (
  <Goal name="Production" checked={isAccepted(products)} />
));

export default OPGoals;



// WEBPACK FOOTER //
// ./src/components/dashboard/OPGoals.js